import React, { Component } from 'react';
import PropTypes from 'prop-types';
import IconButton from '@material-ui/core/IconButton';
import { withStyles } from '@material-ui/core/styles';
import { queryListStyles } from '../../Styles/queryStyles';
import { inject, observer } from 'mobx-react';
import CircularProgress from '@material-ui/core/CircularProgress';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import Images from '../../Theme/Images';
import { ReactSVG } from 'react-svg';
import { ExpansionPanelActions } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import { withRouter } from 'react-router-dom';
import { format } from 'timeago.js';

import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Moment from 'moment';
@inject('queryStore', 'commonStore')
@observer
class PendingChat extends Component {



    renderQuerySummary = () => {
        const { classes, item } = this.props
        const { pendingChat } = this.props.queryStore
        return (
            <div>
                <div className={classes.intentHeading}>{pendingChat.msg} !</div>
                <div className={classes.dateContainer}>
                    <span className={classes.intentHeading}>Continue conversation :&nbsp;{pendingChat.chatData.currentIntent && this.props.commonStore.modifyText(pendingChat.chatData.currentIntent)}</span>
                    <span className={classes.time}><ReactSVG className={classes.detailIcon} src={Images.time} />&nbsp;{format(pendingChat.chatData.createdAt)}</span>

                </div>
            </div>
        )
    }




    onClickSatisfactionButton = (type) => {
        this.props.queryStore.setShowFeedback(true);
        this.props.commonStore.setGoBackTo('pendingQueries')
        this.props.history.push({
            pathname: '/feedback',
            appState: { item: this.props.item, type: type }
        })
    }

    renderSatisfactionButtons = () => {
        const { classes } = this.props;
        return (
            <div className={classes.footerContainer}>
                <Button className={classes.footerButton} type="submit" onClick={(event) => this.onClickSatisfactionButton('satisfied')}>
                    Satisfied
                </Button>
                <Button className={classes.footerButton} type="submit" onClick={(event) => this.onClickSatisfactionButton('dissatisfied')}>
                    Dissatisfied
                </Button>
            </div>
        )
    }

    render() {
        const { classes } = this.props;
        const { pendingChat, inProgress } = this.props.queryStore
        return (
            pendingChat && pendingChat.chatData ?
                <div onClick={(e) => this.props.history.push(`/chat`)}>
                    <Card className={classes.latestQueryCard}>
                        {this.renderQuerySummary()}
                    </Card>


                </div>
                : null
        )
    }
}
PendingChat.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withRouter((withStyles(queryListStyles)(PendingChat)));
